import { notification } from 'antd'

import HqRoleAPI from '@apis/hq/role'

import ConfirmModal from '@components/molecules/ConfirmModal'

type Props = {
  hqId: number
  hqRoleId?: number
  visible: boolean
  onClose: () => void
  onDone?: () => void
}

export default function DeleteModal({ hqId, hqRoleId, visible, onClose, onDone }: Props): JSX.Element {
  const onConfirm = async () => {
    if (!hqRoleId) return
    await HqRoleAPI.deleteRole({ hqId, hqRoleId })
    notification.success({ message: '제거되었습니다.' })

    if (onDone) onDone()
  }

  return (
    <ConfirmModal
      title="권한제거"
      description="권한이 제거됩니다."
      visible={visible}
      okText="제거"
      onConfirm={onConfirm}
      onClose={onClose}
    />
  )
}
